import HistoryIcon from './HistoryIcon';

export default HistoryIcon;
